import React from 'react'
import PropTypes from 'prop-types'
import { emailRegex } from 'variables'
import { withTranslation } from 'react-i18next'
import styled from 'react-emotion'
import FormElement from '../FormElement'
import { color } from '../../../style'

const Tag = styled(({ email, remove, className }) => {
  return (
    <span className={className}>
      {email}
      <i onClick={() => remove(email)}>{String.fromCharCode(215)}</i>
    </span>
  )
})(({ email }) => ({
  label: 'Tag',
  flex: 'none',
  marginRight: '10px',
  fontWeight: '500',
  maxWidth: '100%',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  position: 'relative',
  paddingRight: '20px',
  color: !emailRegex.test(email) && color.red,
  i: {
    fontWeight: '600',
    fontSize: '19px',
    paddingLeft: '4px',
    lineHeight: '23px',
    cursor: 'pointer',
    position: 'absolute',
    right: '0',
    top: '0',
    height: '100%'
  }
}))

Tag.propTypes = {
  email: PropTypes.string.isRequired,
  remove: PropTypes.func.isRequired
}

export const EmailMultiInput = styled(
  ({ emails = [], remove, t, className, ...props }) => (
    <FormElement
      Component="label"
      large
      stretch
      className={className}
      htmlFor="invite-email-input" // focus input on click
    >
      {emails.map(email => (
        <Tag email={email} key={email} remove={remove} />
      ))}
      <input
        id="invite-email-input"
        placeholder={t('share.emailAddress')}
        {...props}
      />
    </FormElement>
  )
)({
  label: 'EmailMultiInput',

  flex: '1',
  padding: '0',
  paddingTop: '7px',
  paddingBottom: '6px',
  border: 'none',
  flexWrap: 'wrap',
  height: 'auto',
  width: '298px',
  lineHeight: '24px',

  input: {
    border: 'none',
    background: 'transparent',
    width: '100%',
    padding: '4px 0'
  }
})

EmailMultiInput.propTypes = {
  emails: PropTypes.array,
  remove: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired
}

export default withTranslation()(EmailMultiInput)
